import React from "react";
import { IRecentInquiries } from "../../../store/credit/types";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";

interface IProps {
    data?: IRecentInquiries[];
}

const CreditHistoryRecentInquiriesSingle: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    return (
        <React.Fragment>
            {props.data != null && props.data.length > 0 ? (
                <React.Fragment>
                    <h4 className=" margin-vertical-s">{props.data[0].bureau}</h4>
                    <div className="table-container scroll">
                        <table className="m-table-generic">
                            <caption className="sr-only">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.recentInquiriesSection.titleInfo")} {props.data[0].bureau}</caption>
                            <thead>
                                <tr>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.recentInquiriesSection.requestor")}</th>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.recentInquiriesSection.dateRequested")}</th>
                                    <th scope="col">{tLang("credit.creditReport.tabs.creditSummarySection.creditHistorySection.recentInquiriesSection.type")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map((inquiry) => (
                                    <tr key={inquiry.index}>
                                        <td>{inquiry.requestor}</td>
                                        <td>{inquiry["date-requested"] && getFormattedDate(i18nService.get("Country"), inquiry["date-requested"])}</td>
                                        <td>{inquiry["inquery-type"]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            ) : (
                ""
            )}
        </React.Fragment>
    );
};

export default CreditHistoryRecentInquiriesSingle;
